import "./video-with-text-block.scss";